import script from "./InfoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoSection.vue?vue&type=script&setup=true&lang=js"

import "./InfoSection.vue?vue&type=style&index=0&id=107ea7b5&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-107ea7b5"]])

export default __exports__